<template>
	<svg
		id="Group_45899"
		data-name="Group 45899"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		width="30"
		height="30"
		viewBox="0 0 30 30"
	>
		<defs>
			<clipPath id="clip-path-my-teams">
				<rect id="Rectangle_15496" data-name="Rectangle 15496" width="30" height="30" fill="none" />
			</clipPath>
		</defs>
		<g id="Group_45896" data-name="Group 45896" clip-path="url(#clip-path-my-teams)">
			<path id="Path_33034" data-name="Path 33034" d="M30,15A15,15,0,1,0,15,30,15,15,0,0,0,30,15" fill="#fff" />
			<path id="Path_33035" data-name="Path 33035" d="M30,15A15,15,0,1,0,15,30,15,15,0,0,0,30,15" fill="#969bae" />
			<path
				id="Path_33036"
				data-name="Path 33036"
				d="M10.98,11.869A3.122,3.122,0,0,0,14.009,8.9a3.107,3.107,0,0,0-2.98-3.04A3.112,3.112,0,0,0,8,8.8a3.106,3.106,0,0,0,2.979,3.067"
				transform="translate(4 2.93)"
				fill="#fff"
			/>
			<path
				id="Path_33037"
				data-name="Path 33037"
				d="M7.3,12.184A2.2,2.2,0,0,0,9.482,9.925,2.214,2.214,0,1,0,7.3,12.184"
				transform="translate(2.527 3.865)"
				fill="#fff"
			/>
			<path
				id="Path_33038"
				data-name="Path 33038"
				d="M14.169,12.188a2.2,2.2,0,0,0,2.256-2.211,2.211,2.211,0,1,0-2.256,2.211"
				transform="translate(6.001 3.865)"
				fill="#fff"
			/>
			<path
				id="Path_33039"
				data-name="Path 33039"
				d="M21.455,14.534a3.279,3.279,0,0,0-2.306-2.919,2.609,2.609,0,0,0-1.874,0,4.269,4.269,0,0,0-.744.357,4.528,4.528,0,0,0-3.474-1.833,4.324,4.324,0,0,0-2.854.881,5.408,5.408,0,0,0-.93.886,4.44,4.44,0,0,0-.632-.291,2.325,2.325,0,0,0-.982-.171c-.021,0-.041,0-.063,0a3.309,3.309,0,0,0-2.071.76,3.548,3.548,0,0,0-1.25,3.266.66.66,0,0,0,.723.67c.084,0,.167,0,.251,0H20.542c.084,0,.168,0,.25,0a.671.671,0,0,0,.693-.727,7.09,7.09,0,0,0-.03-.875"
				transform="translate(2.128 5.068)"
				fill="#fff"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'MyTeamSvg',
};
</script>
